import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { CREATE_NEW_PROGRAM_DATA, CREATE_NEW_PROGRAM_DATA_ERROR, CREATE_NEW_PROGRAM_DATA_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* createNewProgram({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/program`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status >= 200 && response.status < 300) {
      yield put({
        type: CREATE_NEW_PROGRAM_DATA_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CREATE_NEW_PROGRAM_DATA_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_NEW_PROGRAM_DATA_ERROR, payload: error });
  }
}

export function* watchCreateNewProgram() {
  yield takeEvery(CREATE_NEW_PROGRAM_DATA, createNewProgram);
}

function* getCreateNewProgramSaga() {
  yield all([fork(watchCreateNewProgram)]);
}

export default getCreateNewProgramSaga;
